/**
 * External dependencies
 */
import { Reducer } from 'redux';

/**
 * Internal dependencies
 */
import { setInvitationError } from '@/store/actions/invitation';
import initialState from '../../initialState';
import isAction from '../../isAction';

const error: Reducer<boolean | null> = (
	state = initialState.invitation.error,
	action
) => (isAction(action, setInvitationError) ? action.payload : state);

export default error;
